import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var getAllAliases = function getAllAliases(name, aliases) {
  var _aliases = [];
  if (name) {
    _aliases.push(name);
  }
  if (aliases) {
    var _iterator = _createForOfIteratorHelper(aliases),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var alias = _step.value;
        _aliases.push(alias);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return _aliases;
};
var getMiddlewareNameWithAliases = function getMiddlewareNameWithAliases(name, aliases) {
  return "".concat(name || "anonymous").concat(aliases && aliases.length > 0 ? " (a.k.a. ".concat(aliases.join(","), ")") : "");
};
export var constructStack = function constructStack() {
  var absoluteEntries = [];
  var relativeEntries = [];
  var _identifyOnResolve = false;
  var entriesNameSet = new Set();
  var sort = function sort(entries) {
    return entries.sort(function (a, b) {
      return stepWeights[b.step] - stepWeights[a.step] || priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
    });
  };
  var removeByName = function removeByName(toRemove) {
    var isRemoved = false;
    var filterCb = function filterCb(entry) {
      var aliases = getAllAliases(entry.name, entry.aliases);
      if (aliases.includes(toRemove)) {
        isRemoved = true;
        var _iterator2 = _createForOfIteratorHelper(aliases),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var alias = _step2.value;
            entriesNameSet.delete(alias);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var removeByReference = function removeByReference(toRemove) {
    var isRemoved = false;
    var filterCb = function filterCb(entry) {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        var _iterator3 = _createForOfIteratorHelper(getAllAliases(entry.name, entry.aliases)),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var alias = _step3.value;
            entriesNameSet.delete(alias);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  var cloneTo = function cloneTo(toStack) {
    var _toStack$identifyOnRe;
    absoluteEntries.forEach(function (entry) {
      toStack.add(entry.middleware, _objectSpread({}, entry));
    });
    relativeEntries.forEach(function (entry) {
      toStack.addRelativeTo(entry.middleware, _objectSpread({}, entry));
    });
    (_toStack$identifyOnRe = toStack.identifyOnResolve) === null || _toStack$identifyOnRe === void 0 ? void 0 : _toStack$identifyOnRe.call(toStack, stack.identifyOnResolve());
    return toStack;
  };
  var expandRelativeMiddlewareList = function expandRelativeMiddlewareList(from) {
    var expandedMiddlewareList = [];
    from.before.forEach(function (entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, _toConsumableArray(expandRelativeMiddlewareList(entry)));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach(function (entry) {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push.apply(expandedMiddlewareList, _toConsumableArray(expandRelativeMiddlewareList(entry)));
      }
    });
    return expandedMiddlewareList;
  };
  var getMiddlewareList = function getMiddlewareList() {
    var debug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var normalizedAbsoluteEntries = [];
    var normalizedRelativeEntries = [];
    var normalizedEntriesNameMap = {};
    absoluteEntries.forEach(function (entry) {
      var normalizedEntry = _objectSpread(_objectSpread({}, entry), {}, {
        before: [],
        after: []
      });
      var _iterator4 = _createForOfIteratorHelper(getAllAliases(normalizedEntry.name, normalizedEntry.aliases)),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var alias = _step4.value;
          normalizedEntriesNameMap[alias] = normalizedEntry;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach(function (entry) {
      var normalizedEntry = _objectSpread(_objectSpread({}, entry), {}, {
        before: [],
        after: []
      });
      var _iterator5 = _createForOfIteratorHelper(getAllAliases(normalizedEntry.name, normalizedEntry.aliases)),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var alias = _step5.value;
          normalizedEntriesNameMap[alias] = normalizedEntry;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach(function (entry) {
      if (entry.toMiddleware) {
        var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === undefined) {
          if (debug) {
            return;
          }
          throw new Error("".concat(entry.toMiddleware, " is not found when adding ") + "".concat(getMiddlewareNameWithAliases(entry.name, entry.aliases), " ") + "middleware ".concat(entry.relation, " ").concat(entry.toMiddleware));
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    var mainChain = sort(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce(function (wholeList, expandedMiddlewareList) {
      wholeList.push.apply(wholeList, _toConsumableArray(expandedMiddlewareList));
      return wholeList;
    }, []);
    return mainChain;
  };
  var stack = {
    add: function add(middleware) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var name = options.name,
        override = options.override,
        _aliases = options.aliases;
      var entry = _objectSpread({
        step: "initialize",
        priority: "normal",
        middleware: middleware
      }, options);
      var aliases = getAllAliases(name, _aliases);
      if (aliases.length > 0) {
        if (aliases.some(function (alias) {
          return entriesNameSet.has(alias);
        })) {
          if (!override) throw new Error("Duplicate middleware name '".concat(getMiddlewareNameWithAliases(name, _aliases), "'"));
          var _iterator6 = _createForOfIteratorHelper(aliases),
            _step6;
          try {
            var _loop = function _loop() {
              var alias = _step6.value;
              var toOverrideIndex = absoluteEntries.findIndex(function (entry) {
                var _entry$aliases;
                return entry.name === alias || ((_entry$aliases = entry.aliases) === null || _entry$aliases === void 0 ? void 0 : _entry$aliases.some(function (a) {
                  return a === alias;
                }));
              });
              if (toOverrideIndex === -1) {
                return "continue";
              }
              var toOverride = absoluteEntries[toOverrideIndex];
              if (toOverride.step !== entry.step || entry.priority !== toOverride.priority) {
                throw new Error("\"".concat(getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases), "\" middleware with ") + "".concat(toOverride.priority, " priority in ").concat(toOverride.step, " step cannot ") + "be overridden by \"".concat(getMiddlewareNameWithAliases(name, _aliases), "\" middleware with ") + "".concat(entry.priority, " priority in ").concat(entry.step, " step."));
              }
              absoluteEntries.splice(toOverrideIndex, 1);
            };
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _ret = _loop();
              if (_ret === "continue") continue;
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        }
        var _iterator7 = _createForOfIteratorHelper(aliases),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var alias = _step7.value;
            entriesNameSet.add(alias);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: function addRelativeTo(middleware, options) {
      var name = options.name,
        override = options.override,
        _aliases = options.aliases;
      var entry = _objectSpread({
        middleware: middleware
      }, options);
      var aliases = getAllAliases(name, _aliases);
      if (aliases.length > 0) {
        if (aliases.some(function (alias) {
          return entriesNameSet.has(alias);
        })) {
          if (!override) throw new Error("Duplicate middleware name '".concat(getMiddlewareNameWithAliases(name, _aliases), "'"));
          var _iterator8 = _createForOfIteratorHelper(aliases),
            _step8;
          try {
            var _loop2 = function _loop2() {
              var alias = _step8.value;
              var toOverrideIndex = relativeEntries.findIndex(function (entry) {
                var _entry$aliases2;
                return entry.name === alias || ((_entry$aliases2 = entry.aliases) === null || _entry$aliases2 === void 0 ? void 0 : _entry$aliases2.some(function (a) {
                  return a === alias;
                }));
              });
              if (toOverrideIndex === -1) {
                return "continue";
              }
              var toOverride = relativeEntries[toOverrideIndex];
              if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
                throw new Error("\"".concat(getMiddlewareNameWithAliases(toOverride.name, toOverride.aliases), "\" middleware ") + "".concat(toOverride.relation, " \"").concat(toOverride.toMiddleware, "\" middleware cannot be overridden ") + "by \"".concat(getMiddlewareNameWithAliases(name, _aliases), "\" middleware ").concat(entry.relation, " ") + "\"".concat(entry.toMiddleware, "\" middleware."));
              }
              relativeEntries.splice(toOverrideIndex, 1);
            };
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _ret2 = _loop2();
              if (_ret2 === "continue") continue;
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
        var _iterator9 = _createForOfIteratorHelper(aliases),
          _step9;
        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var alias = _step9.value;
            entriesNameSet.add(alias);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }
      relativeEntries.push(entry);
    },
    clone: function clone() {
      return cloneTo(constructStack());
    },
    use: function use(plugin) {
      plugin.applyToStack(stack);
    },
    remove: function remove(toRemove) {
      if (typeof toRemove === "string") return removeByName(toRemove);else return removeByReference(toRemove);
    },
    removeByTag: function removeByTag(toRemove) {
      var isRemoved = false;
      var filterCb = function filterCb(entry) {
        var tags = entry.tags,
          name = entry.name,
          _aliases = entry.aliases;
        if (tags && tags.includes(toRemove)) {
          var aliases = getAllAliases(name, _aliases);
          var _iterator10 = _createForOfIteratorHelper(aliases),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var alias = _step10.value;
              entriesNameSet.delete(alias);
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: function concat(from) {
      var _from$identifyOnResol, _from$identifyOnResol2;
      var cloned = cloneTo(constructStack());
      cloned.use(from);
      cloned.identifyOnResolve(_identifyOnResolve || cloned.identifyOnResolve() || ((_from$identifyOnResol = (_from$identifyOnResol2 = from.identifyOnResolve) === null || _from$identifyOnResol2 === void 0 ? void 0 : _from$identifyOnResol2.call(from)) !== null && _from$identifyOnResol !== void 0 ? _from$identifyOnResol : false));
      return cloned;
    },
    applyToStack: cloneTo,
    identify: function identify() {
      return getMiddlewareList(true).map(function (mw) {
        var _mw$step;
        var step = (_mw$step = mw.step) !== null && _mw$step !== void 0 ? _mw$step : mw.relation + " " + mw.toMiddleware;
        return getMiddlewareNameWithAliases(mw.name, mw.aliases) + " - " + step;
      });
    },
    identifyOnResolve: function identifyOnResolve(toggle) {
      if (typeof toggle === "boolean") _identifyOnResolve = toggle;
      return _identifyOnResolve;
    },
    resolve: function resolve(handler, context) {
      var _iterator11 = _createForOfIteratorHelper(getMiddlewareList().map(function (entry) {
          return entry.middleware;
        }).reverse()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var middleware = _step11.value;
          handler = middleware(handler, context);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      if (_identifyOnResolve) {
        console.log(stack.identify());
      }
      return handler;
    }
  };
  return stack;
};
var stepWeights = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
var priorityWeights = {
  high: 3,
  normal: 2,
  low: 1
};